<template>
  <div>
    <p class="mb-3">
      Which of the following is not a valid (i.e. non-H atoms obey the octet rule and the total
      number of electrons is correct) Lewis structure for
      <stemble-latex content="$\ce{C2H4O?}$" />
    </p>

    <p class="mb-1 pl-3">
      <img :src="$publicAsset('/img/assignments/C2H4O_LS.png')" width="520px" />
    </p>

    <v-form @submit.prevent="submitResponse">
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing">
        <v-radio
          v-for="option in options"
          :key="option.value"
          class="d-inline-block"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question321',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking

      inputs: {
        input1: null,
      },
      options: [
        {text: '$\\text{Structure A}$', value: 'a'},
        {text: '$\\text{Structure B}$', value: 'b'},
        {text: '$\\text{Structure C}$', value: 'c'},
        {text: '$\\text{Structure D}$', value: 'd'},
        {text: '$\\text{Structure E}$', value: 'e'},
      ],
    };
  },
};
</script>
